import { render, staticRenderFns } from "./ArticleByline.vue?vue&type=template&id=101136db"
import script from "./ArticleByline.vue?vue&type=script&lang=js"
export * from "./ArticleByline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports